<script lang="ts">
    import type { HTMLElement } from "node-html-parser"
    import type { SvelteComponent } from "svelte"
    import LadeAnimation from "../LadeAnimation.svelte"
    import CustomTagsChildren from "./CustomTagsChildren.svelte"
    export let html: string
    export let tags: { [key: string]: typeof SvelteComponent } = {}
    export let additionalProps: { [key: string]: any } = { html }

    let nodes: HTMLElement[]
    import("node-html-parser").then((m) => {
        const { parse } = m.default
        console.log("PARSER LOADED")
        nodes = parse(html).childNodes as HTMLElement[]
    })
</script>

{#if nodes}
    <CustomTagsChildren
        nodes="{nodes}"
        tags="{tags}"
        additionalProps="{additionalProps}"
    />
{:else}
    <LadeAnimation />
{/if}
